<template>
  <basic-container>
    <div style="font-size: 20px; margin-top: 10px;"> 渠道会员激活日志 </div>
    <avue-crud
        :option="option"
        :data="data"
        ref="crud"
        v-model="form"
        :permission="permissionList"
        @row-del="rowDel"
        @row-update="rowUpdate"
        @row-save="rowSave"
        :before-open="beforeOpen"
        :page.sync="page"
        @refresh-change="refreshChange"
        @search-change="searchChange"
        @search-reset="searchReset"
        @selection-change="selectionChange"
        @current-change="currentChange"
        @size-change="sizeChange"
        :header-cell-class-name="headerCellClassName"
        @on-load="onLoad">
      <template slot="menuLeft">
        <!-- <el-button
            type="danger"
            size="small"
            icon="el-icon-delete"
            plain
            v-if="permission.sys_user_delete"
            @click="handleDelete">删 除
        </el-button> -->
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import { getList, getDetail, remove, submit } from '@/api/health/UserChannelVipLog'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      form: {},
      selectionList: [],
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      init: {
        roleTree: [],
        deptTree: []
      },
      headerCellClassName: 'headerClass',
      option: {
        tip: false,
        border: true,
        index: true,
        selection: false,
        viewBtn: false,
        dialogHeight: 450,
        delBtn: false,
        editBtn: false,
        addBtn: false,
        menu: false,
        column: [
          {
            label: '用户名',
            prop: 'userName'
          },
          {
            label: '手机号',
            prop: 'phone'
          },
          {
            label: '渠道名称',
            prop: 'channel'
          },
          {
            label: '会员类型',
            prop: 'vipType',
            dicData: [
              { label: '普通用户', value: 0 },
              { label: '基础会员', value: 1 },
              { label: '体验会员', value: 2 },
              { label: '全年会员', value: 3 },
              { label: 'vip会员', value: 6 }
            ]
          },
          {
            label: '会员开始时间',
            prop: 'vipPurchase'
          },
          {
            label: '会员到期时间',
            prop: 'vipExpired'
          },
          {
            label: '创建时间',
            prop: 'createTime',
            addDisplay: false,
            editDisabled: true,
            cell: false
          },
          {
            label: '修改时间',
            prop: 'updateTime',
            addDisplay: false,
            editDisabled: true,
            cell: false
          }
        ]
      },
      data: []
    }
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList () {
      return {
        addBtn: this.vaildData(this.permission.sys_user_add, false),
        viewBtn: this.vaildData(this.permission.sys_user_view, false),
        delBtn: this.vaildData(this.permission.sys_user_delete, false),
        editBtn: this.vaildData(this.permission.sys_user_edit, false)
      }
    },
    ids () {
      const ids = []
      this.selectionList.forEach(ele => {
        ids.push(ele.id)
      })
      return ids.join(',')
    }
  },
  methods: {
    rowSave (row, loading, done) {
      row.surplusFrequency = row.totalFrequency
      submit(row).then(() => {
        loading()
        this.onLoad(this.page)
        this.$message({
          type: 'success',
          message: '操作成功!'
        })
      }, () => {
        done()
      })
    },
    rowUpdate (row, index, loading, done) {
      submit(row).then(() => {
        loading()
        this.onLoad(this.page)
        this.$message({
          type: 'success',
          message: '操作成功!'
        })
      }, () => {
        done()
      })
    },
    rowDel (row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          return remove(row.id)
        })
        .then(() => {
          this.onLoad(this.page)
          this.$message({
            type: 'success',
            message: '操作成功!'
          })
        })
    },
    searchReset () {
      this.onLoad(this.page)
    },
    searchChange (params, done) {
      this.onLoad(this.page, params, done)
    },
    selectionChange (list) {
      this.selectionList = list
    },
    handleDelete () {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据')
        return
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          return remove(this.ids)
        })
        .then(() => {
          this.onLoad(this.page)
          this.$message({
            type: 'success',
            message: '操作成功!'
          })
          this.$refs.crud.toggleSelection()
        })
    },
    beforeOpen (done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail(this.form.id).then(res => {
          this.form = res.data
        })
      }
      done()
    },
    refreshChange (data) {
      this.onLoad(this.page, data.searchForm)
    },
    currentChange (currentPage) {
      this.page.currentPage = currentPage
    },
    sizeChange (pageSize) {
      this.page.pageSize = pageSize
    },
    onLoad (page, params = {}, done) {
      getList(page.currentPage, page.pageSize, params).then(res => {
        console.log('test getList')
        console.log(res)
        const data = res.data
        this.page.total = data.total
        this.data = data.records
        if (done) {
          done()
        }
      })
    }
  }
}
</script>
<style>
.headerClass{
      background-color: #409EFF !important;
      color:#FFF !important;
    }
</style>
